var render = function render(_c,_vm){return _c('div',[_c('transition',{attrs:{"name":"slide-top","mode":"out-in"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }